import { Outlet } from "react-router-dom";
import BottomNav from "../components/BottomNav";

export default function MobileLayout() {
  return (
    <>
      <style>{`
        .mobile-layout{
          position: relative;
          min-height: 100dvh;

          background: #0b0a08;
          overflow-x: hidden;
        }

        .mobile-page{
          min-height: 100dvh;
          padding-bottom: 88px;
        }
      `}</style>

      <div className="mobile-layout">

        <div className="mobile-page">
          <Outlet />
        </div>

        {/* <BottomNav /> */}

      </div>
    </>
  );
}